import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";

export const requestOTP = async (body) => {
    return apiClient.post(ENDPOINTS.requestOtp, body);
};

export const verifyOTP = async (body) => {
    return apiClient.post(ENDPOINTS.verifyOtp, body);
};
